import { ChangeDetectorRef, Component} from '@angular/core';
import {AlertController, ModalController, NavController, NavParams} from 'ionic-angular';
import { FormBuilder, FormGroup } from "@angular/forms";
import { ApiService } from "../../services/api.service";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import { UnitPage } from "../unit/unit";
import { UnitSearchHistoryService } from "../../services/unit-search-history.service";
import {SearchLocationUnitsPage} from "../search-location-units/search-location-units";

@Component({
  selector: 'page-search-unit',
  templateUrl: 'search-unit.html',
})
export class SearchUnitPage {

  busy = false;
  searchPerformed = false;
  searchForm: FormGroup;
  history = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public apiService: ApiService,
    public alertCtrl: AlertController,
    public historyService: UnitSearchHistoryService,
    public barcodeScanner: BarcodeScanner,
    public modalCtrl: ModalController,
    public changeDetector: ChangeDetectorRef
  ) {
    this.searchForm = this.formBuilder.group({
      code: [''],
      unit_id: ['']
    });
  }

  scanBarcode(){
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      console.log('Barcode data', data);
      let barcode = data.text;
      if(barcode.lastIndexOf('/') > 0) {
        barcode = barcode.substring(barcode.lastIndexOf('/') + 1);
      }
      if(barcode){
        this.searchForm.get('code').setValue(barcode);
        this.search(null);
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  search(history_record){
    if(!this.searchForm.valid) return;
    let code = this.searchForm.value.code;
    let unit_id = this.searchForm.value.unit_id;
    if(!code && !unit_id){
      return;
    }
    this.busy = true;
    this.searchPerformed = false;
    this.apiService.getUnitByPassportNr(code, unit_id).then((data:any) => {
      this.searchPerformed = true;
      this.busy = false;
      if(data && data.unit_id){
        if(!this.hasActiveSubscription(data)){
          // Als er geen licentie is voor dit type unit, waarschuwing weergeven
          this.alertCtrl.create({
            title: 'Geen licentie',
            message: 'Het is niet mogelijk dit toestel te bekijken, omdat u geen licentie heeft voor dit type installatie.',
            buttons: ['OK']
          }).present();
        } else {
          // Opslaan in history en openen
          this.historyService.setRecord(data).then(() => {
            this.navCtrl.push(UnitPage, {
              unit: data
            });
          }).catch(() => {});
        }
      } else {
        this.alertCtrl.create({
          message: 'Er kon geen installatie worden gevonden met deze code.',
          cssClass: 'alert-error',
          buttons: ['OK']
        }).present();
      }
    }).catch((error) => {
      this.searchPerformed = true;
      this.busy = false;
      console.error(error);
      // Open history record
      if(history_record){
        this.navCtrl.push(UnitPage, {
          unit: history_record
        });
      } else {
        this.alertCtrl.create({
          message: 'Er kon geen verbinding worden gemaakt met de server. Controleer uw internetverbinding.',
          cssClass: 'alert-error',
          buttons: ['OK']
        }).present();
      }
    });
  }

  hasActiveSubscription(unit){
    const type = parseInt(unit.unit_model_unit_type, 10);
    switch(type){
      case 1:
        return this.apiService.hasActiveSubscription('UNIT_CV');
      case 2:
        return this.apiService.hasActiveSubscription('UNIT_VENTILATIE');
      case 3:
        return this.apiService.hasActiveSubscription('UNIT_WATERONTHARDER');
      case 4:
        return this.apiService.hasActiveSubscription('UNIT_HIJSTOESTEL');
      case 5:
        return this.apiService.hasActiveSubscription('UNIT_AIRCO');
      case 9:
        return this.apiService.hasActiveSubscription('UNIT_GAS_OF_SFEERHAARD');
    }
    return true;
  }

  searchByCode(code){
    this.searchForm.get('code').setValue(code);
    this.searchForm.get('unit_id').setValue('');
    this.search(null);
  }

  searchByUnitId(unit_id){
    this.searchForm.get('unit_id').setValue(unit_id);
    this.searchForm.get('code').setValue('');
    this.search(null);
  }

  openHistory(history_record){
    let code = history_record.passport_nr;
    let unit_id = history_record.unit_id;
    this.searchForm.get('code').setValue(code);
    this.searchForm.get('unit_id').setValue(unit_id);
    this.search(history_record);
  }

  deleteRecord(record){
    this.historyService.deleteRecord(record._id).then(() => {
      this.loadHistory();
    }).catch(() => {
      this.loadHistory();
    });
  }

  loadHistory(){
    this.historyService.getAll().then((data) => {
      // @ts-ignore
      this.history = data;
      this.history.reverse();
      this.changeDetector.detectChanges();
      console.log(this.history);
    }).catch(() => {
      this.history = [];
      this.changeDetector.detectChanges();
    });
  }

  searchLocationUnits(){
    this.modalCtrl.create(SearchLocationUnitsPage, {
      page: this
    }).present();
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter SearchUnitPage');
    this.loadHistory();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SearchUnitPage');
    let code = this.navParams.get('code');
    if(code){
      this.searchByCode(code);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/search-unit/search-unit.ts